

import { Layout, Row, Col, Card, Statistic, Select } from "antd";
import VcSideNav from "../DeviceHome/VcSideNav";
import VcMaps from "../VcMaps";
import { useState, useContext, useEffect } from "react";
import { AppRelevantDataContext} from '../../../AppContext';
import { IDS_MapCityTitle, IDS_MapDistictTitle, IDS_MapStateTitle, IDS_MapPincodeTitle, IDS_MapTerritoryTitle, IDS_SelectCity, IDS_SelectDistrict, IDS_SelectState, IDS_SelectPincode, IDS_SelectTerritory } from ".././../../VcLanguage";

const { Option } = Select;

var criticalCount = 890; // Example value for critical sites count

const { Content } = Layout;

function VcMapLayout (props) {

  const { filters, setFilters, options, maps, getBPCLToilet, setGetBPCLToilet } = props;
  const context = useContext(AppRelevantDataContext);

  let appRelevantDataContextValue = context;
  let t = appRelevantDataContextValue.t; 

  useEffect(() => {
    setFilters({
      state: null,
      territory: null,
      district: null,
      city: null,
      pincode: null,
    });
    setGetBPCLToilet(false);
  }, []);

  useEffect(() => {
    if (!getBPCLToilet) {
      setFilters(prev => ({
        ...prev,
        territory: null
      }));
    }
  }, [getBPCLToilet]);

  const handleChange = (type, value) => {
  
    if (type === "territory") {
      setFilters(prev => ({
        ...prev,
        territory: value
      }));
      return;
    }
  
    let newFilters = { ...filters };
  
    if (!value) {
      newFilters[type] = null;
  
      if (type === "state") {
        newFilters.district = null;
        newFilters.city = null;
        newFilters.pincode = null;
      }
  
      if (type === "district") {
        newFilters.city = null;
        newFilters.pincode = null;
      }
  
      if (type === "city") {
        newFilters.pincode = null;
      }
  
      setFilters(newFilters);
      // updateOptions(newFilters);
      return;
    }
  
    newFilters[type] = value;
  
    if (type === "state") {
      newFilters.district = null;
      newFilters.city = null;
      newFilters.pincode = null;
    }
  
    if (type === "district") {
      newFilters.city = null;
      newFilters.pincode = null;
    }
  
    if (type === "city") {
      newFilters.pincode = null;
    }
  
    setFilters(newFilters);
  };

  const FilterSection = () => {
    return (
      <Row style={{ marginBottom: "5px" }}>
        <Col span={24}>
          <Card size="small" bodyStyle={{ padding: "8px 12px" }}>
            <div
              style={{
                display: "flex",
                gap: 8,
                overflowX: "auto",
                overflowY: "hidden",
                WebkitOverflowScrolling: "touch",
                scrollbarWidth: "thin",
                paddingBottom: "4px",
              }}
            >
              {[
                { key: "state",     label: t(IDS_MapStateTitle),     placeholder: t(IDS_SelectState),     show: true },
                { key: "territory", label: t(IDS_MapTerritoryTitle), placeholder: t(IDS_SelectTerritory), show: getBPCLToilet === true },
                { key: "district",  label: t(IDS_MapDistictTitle),   placeholder: t(IDS_SelectDistrict),  show: true },
                { key: "city",      label: t(IDS_MapCityTitle),      placeholder: t(IDS_SelectCity),      show: true },
                { key: "pincode",   label: t(IDS_MapPincodeTitle),   placeholder: t(IDS_SelectPincode),   show: true },
              ]
                .filter(f => f.show)
                .map(f => (
                  <div
                    key={f.key}
                    style={{
                      flex: "1 1 0",       
                      minWidth: "120px",  
                    }}
                  >
                    <div style={{ fontSize: 12, whiteSpace: "nowrap", textAlign: "left" }}>{f.label}</div>
                    <Select
                      showSearch
                      allowClear
                      popupMatchSelectWidth={false}  
                      placeholder={f.placeholder}
                      value={filters[f.key]}
                      style={{ width: "100%" }}
                      onChange={(v) => handleChange(f.key, v)}
                      options={options[f.key] || []}
                    />
                  </div>
                ))}
            </div>
          </Card>
        </Col>
      </Row>
    );
  };

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      <Layout style={{ padding: "10px", background: "#f5f6fa", height: "100%" }}>
        <Content style={{ display: "flex", flexDirection: "column", height: "100%" }}>

          {/* Filters */}
          {FilterSection()}

          {/* Map — takes remaining space */}
          <Col span={24} style={{ flex: 1, minHeight: 0 }}>
            <Card
              bodyStyle={{ padding: 0, height: "100%" }}
              style={{ height: "100%" }}
            >
              <div style={{ height: "100%", width: "100%" }}>
                <VcMaps
                  invokedFrom="mapsLayout"
                  filters={filters}
                  getBPCLToilet={getBPCLToilet}
                  setGetBPCLToilet={setGetBPCLToilet}
                />
              </div>
            </Card>
          </Col>

        </Content>
      </Layout>
    </div>
  );
}
export default VcMapLayout;

// import React, { useState } from 'react';

// // import VcMapSummaryCard from '../../JS/MapHome/VcMapSummaryCard';
// import VcMapSummaryCard from './VcMapSummaryCard';
// import VcMaps from '../VcMaps';

// const VcMapLayout = () => {
//     const [mapCenter, setMapCenter] = useState({ lat: 0, lng: 0 });
//     const [state, setState] = useState({state: []})



//     function IndiaOverview({state}){

//     return(

//     <div className="panel-section">

//     <h3>India Overview 🇮🇳</h3>

//     {/* <p>Total Toilets: {state.markerDataArr.length}</p> */}
//     <p>Total Toilets: {state.markerDataArr}</p>

//     <p>Avg Odour: {state.odourAvgStarRating}</p>

//     <p>Avg Cleanliness: {state.cleanlinessAvgStarRating}</p>

//     </div>

//     )

//     }

//     function VcMapSummaryCard({title,value}){
        
//     return(
//     <div className="summary-card">

//     <h4>{title}</h4>

//     <div className="summary-value">
//     {value}
//     </div>

//     </div>
//     )

//     }

//     return (
//         <div className="map-dashboard">

//         {/* Top Summary Cards */}
//         <div className="map-summary-row">
//             <VcMapSummaryCard title="Total Toilets" value={state.markerDataArr} />
//             <VcMapSummaryCard title="Avg Cleanliness" value={state.cleanlinessAvgStarRating} />
//             <VcMapSummaryCard title="Avg Odour" value={state.odourAvgStarRating} />
//             {/* <VcMapSummaryCard title="Online Devices" value={calculateOnlineDevices()} />  */}
//             {/* <VcMapSummaryCard title="Avg NH3OD" value={calculateAvgNH3()} /> */}
//         </div>


//         {/* Main Layout */}
//         <div className="map-main-container">

//                 {/* MAP AREA */}
//                 <div className="map-area">

//                     {/* <GoogleMap
//                         mapContainerClassName="map-container"
//                         center={{lat: state.CurrentLocationLat, lng: state.CurrentLocationLon}}
//                         zoom={6}
//                         onLoad={(map) => setMap(map)}
//                         onDragEnd={onDragEnd}
//                     >

//                         {renderMarkersWithToiletsAndApplicableDevice()}

//                     </GoogleMap> */}
//                     <VcMaps /> 

//                 </div>


//                 {/* ANALYTICS PANEL */}
//                 <div className="map-analytics-panel">

//                     {/* <IndiaOverview state={state} />

//                     <OdourAnalysis state={state} />

//                     <CleanlinessRanking state={state} />

//                     <TopRatedToilets state={state} /> */}

//                 </div>

//         </div>


//         {/* Map Mode Switch */}
//         <div className="map-mode-switch">
// {/* 
//                 <button onClick={()=>setMapMode("normal")}>Normal</button>
//                 <button onClick={()=>setMapMode("cluster")}>Cluster</button>
//                 <button onClick={()=>setMapMode("heatmap")}>Heatmap</button>
//                 <button onClick={()=>setMapMode("all")}>All Toilets</button> */}

//         </div>

//         </div>
//     );



  // return (
  //       <div className='w-100 d-flex relative'>
  //           <div style={{width:"100%", height:"100%" }}>
  //               <Layout style={{ padding: "10px 10px", background: "#f5f6fa" }}>
  //               <Content>

  //                   {/* Filters */}
  //                   {/* <Row gutter={12} style={{ marginBottom: 10 }}>
  //                   <Col span={24}>
  //                       <Card size="small">Filters: State | Territory | City | Date</Card>
  //                   </Col>
  //                   </Row> */}
  //                   {FilterSection()}



  //                   <Col span={24}>
  //                       {/* <Card title="India Heatmap">
  //                       <div style={{height:"100%", width: "100%" }}>
  //                           <VcMaps invokedFrom = "VcMapPg"/>
  //                       </div>  
  //                       </Card> */}
  //                       <Card
  //                       // title="India Heatmap"
  //                       headStyle={{ padding: "6px 12px"}}
  //                       bodyStyle={{ padding: 0 }}
  //                       >
  //                       <div style={{ height: "30%", width: "100%", backgroundColor: "skyblue" }}>
  //                           <VcMaps invokedFrom="VcMapLayout" filters={filters} getBPCLToilet={getBPCLToilet} setGetBPCLToilet={setGetBPCLToilet}/>
  //                       </div>
  //                       </Card>
  //                   </Col>
  //                   {/* KPI Cards */}
  //                   {/* <Row gutter={12} style={{ marginBottom: 10 }}>
  //                   <Col span={6}>
  //                       <Card
  //                           style={{
  //                               background: "linear-gradient(135deg, #1890ff, #36cfc9)",
  //                               color: "white",
  //                               borderRadius: 10
  //                           }}
  //                           >
  //                           <div style={{fontSize:30,fontWeight:600}}><Statistic value={criticalCount} /></div>

  //                           <div>Total Toilets</div>
  //                       </Card>
  //                   </Col>
  //                   <Col span={6}>
  //                       <Card 
  //                           style={{
  //                               background: "linear-gradient(135deg, #13c2c2, #52c41a)",
  //                               color: "white",
  //                               borderRadius: 10
  //                           }}
  //                           > 
  //                           <div style={{fontSize:30,fontWeight:600}}>587</div>
  //                           <div>Active Devices</div>
  //                       </Card>
  //                   </Col>
  //                   <Col span={6}><Card
  //                           style={{
  //                               background: "linear-gradient(135deg, #fa8c16, #ffc53d)",
  //                               color: "white",
  //                               borderRadius: 10
  //                           }}
  //                   >
  //                           <div style={{fontSize:30,fontWeight:600}}>587</div>
  //                           <div>Avg Odor</div>
  //                   </Card></Col>
  //                   <Col span={6}><Card 
  //                           style={{
  //                               background: "linear-gradient(135deg, #ff4d4f, #ff4d4f)",
  //                               color: "white",
  //                               borderRadius: 10
  //                           }}
  //                   >
  //                           <div style={{fontSize:30,fontWeight:600}}>587</div>
  //                           <div>Critical Sites</div>
  //                       </Card></Col>
  //                   </Row> */}

  //                   {/* Map + State Performance */}
  //                   {/* <Row gutter={8} style={{ marginBottom: 2, hright: "50%" }}> */}
                    
  //                   {/* <Col span={8}>
  //                       <Card title="State Performance">
  //                       STATE BAR CHART
  //                       </Card>
  //                   </Col> */}
  //                   {/* </Row> */}

  //                   {/* Analytics Row */}
  //                   {/* <ReactECharts option={option} />  Add This line inside card*/}
  //                   {/* <Row gutter={12} style={{ marginBottom: 10 }}>
  //                   <Col span={8}>
  //                       <Card title="Odor Trend">Chart
  //                       </Card>
  //                   </Col>

  //                   <Col span={8}>
  //                       <Card title="Hourly Pattern">Chart
  //                       </Card>
  //                   </Col>

  //                   <Col span={8}>
  //                       <Card title="Spike Analysis">Chart
  //                       </Card>
  //                   </Col>
  //                   </Row> */}

  //                   {/* Performance Row */}
  //                   {/* <Row gutter={12} style={{ marginBottom: 10 }}>
  //                   <Col span={8}>
  //                       <Card title="Worst Toilets">Table/List</Card>
  //                   </Col>

  //                   <Col span={8}>
  //                       <Card title="Best Toilets">Table/List</Card>
  //                   </Col>

  //                   <Col span={8}>
  //                       <Card title="Device Health">Stats</Card>
  //                   </Col>
  //                   </Row> */}

  //                   {/* Alerts */}
  //                   {/* <li> BPCL223 Odor Greater 80 for 30 min</li> */}
  //                   {/* <Row>
  //                   <Col span={24}>
  //                       <Card title="Live Alerts">
  //                       Alerts List
  //                           <ul>
  //                               <Card
  //                                   style={{
  //                                       borderLeft: "6px solid red",
  //                                       animation: "blink 1.5s infinite"
  //                                   }}
  //                                   >
  //                                    BPCL223 Odor Greater 80 for 30 min
  //                               </Card>
  //                               <li>BPCL344 Device Offline</li>
  //                               <li> BPCL189 Frequent spikes</li>
  //                           </ul>
  //                       </Card>
  //                   </Col>
  //                   </Row> */}

  //               </Content>
  //               </Layout>

  //           {/* <VcMaps invokedFrom = "VcMapPg"/>                   */}
  //           </div>
  //       </div>


  // );
// };

// export default VcMapLayout;


